import isZocdocBrand from './isZocdocBrand';
import { localizedUrlMap } from '../Search/seoRoutes';

export default function getHreflangLinks(theme, hostUrl, url) {
    const links = [];

    if (theme && isZocdocBrand(theme.directoryId) && theme.languages) {
        const { languages } = theme;
        const languageKeys = Object.keys(languages);
        const currentLanguage = languageKeys.filter(key => languages[key].host === hostUrl);
        const otherLanguages = languageKeys.filter(key => languages[key].host !== hostUrl);

        // alternative languages, then current language
        otherLanguages.concat(currentLanguage).forEach(language => {
            links.push({
                rel: 'alternate',
                hreflang: languages[language].hreflang,
                href: `https://${languages[language].host}${url}`,
            });
        });

        // finally push default alternative link
        links.push({
            rel: 'alternate',
            hreflang: 'x-default',
            href: `https://www.zocdoc.com${url}`,
        });
    }

    return links;
}

export function getSearchHrefLangLinks(theme, hostUrl, url) {
    const links = [];

    if (theme && isZocdocBrand(theme.directoryId) && theme.languages) {
        const { languages } = theme;
        const languageKeys = Object.keys(languages);
        const currentDomain = hostUrl.split('.')[0];
        const currentLanguage = languageKeys.filter(key => languages[key].host.startsWith(currentDomain));
        const otherLanguages = languageKeys.filter(key => !languages[key].host.startsWith(currentDomain));
        const firstUrlToken = url.startsWith('/') ? url.split('/')[1] : url.split('/')[0];
        const loweredFirstToken = firstUrlToken.toLowerCase();
        const replacement = localizedUrlMap[loweredFirstToken] || {
            other: firstUrlToken,
            default: firstUrlToken,
        };

        // alternative languages, then current language
        otherLanguages.forEach(language => {
            links.push({
                rel: 'alternate',
                hreflang: languages[language].hreflang,
                href: `https://${languages[language].host}${url.replace(firstUrlToken, replacement.other)}`,
            });
        });

        if (currentLanguage.length > 0) {
            links.push({
                rel: 'alternate',
                hreflang: languages[currentLanguage[0]].hreflang,
                href: `https://${languages[currentLanguage].host}${url}`,
            });
        }
        // finally push default alternative link
        links.push({
            rel: 'alternate',
            hreflang: 'x-default',
            href: `https://www.zocdoc.com${url.replace(firstUrlToken, replacement.default)}`,
        });
    }

    return links;
}
